<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :title="$t('data.transfer')" width="735px" :close-on-click-modal="false" class="diglog-card" @close="handleDialogClose">
      <div class="diglog-container">
        <div class="header-line" />
        <div class="section-title">
          {{ $t('data.transfer_details') }}
        </div>
        <div class="section-tip">
          {{ $t('tips.transfert_enter') }}
        </div>
        <el-form ref="transForm" :model="transForm" status-icon label-position="top">
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('data.sender')">
                <div class="input-show-info">{{ $store.getters.mainUserName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item :label="$t('merchantAccount.current_balance')">
                <div class="input-show-info">{{ $store.getters.currency }}  {{ balance | toDivideWithDot }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('data.receiver')" prop="merchant_id" required>
                <el-select v-model="transForm.merchant_id" class="select-item" :placeholder="$t('data.related_merchants')" clearable @change="onChangeRelatedMch">
                  <el-option
                    v-for="(item,index) in relatedMerchantsList"
                    :key="index"
                    :label="item.merchant_name + '-' + item.merchant_no"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item :label="$t('merchantAccount.current_balance')">
                <div class="input-show-info">{{ $store.getters.currency }}  {{ checkedRelateMch.balance | toDivideWithDot }} </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
            :label="$t('data.transfer_amount')+':'"
            prop="amount"
            :rules="[
              { required: true, message: 'Amount cannot be empty', trigger: 'blur'},
              { validator: checkAmount, trigger: 'blur' }
            ]"
          >
            <el-input v-model="transForm.amount" type="text" autocomplete="off" placeholder="Enter amount" />
          </el-form-item>
          <el-form-item :label="$t('data.remark')">
            <el-input v-model="transForm.remark" type="textarea" autocomplete="off" placeholder="Enter your message here" />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mchRelateTransfer, fetchRelateMchsList } from '@/api/merchant-manage/merchant-manage.js'

export default {
  name: 'Trans_Modal',
  props: {
    merchantInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      this.$commonFn.validateFormAmount({rule, value, callback})
      callback()
    }
    return {
      transForm: {
        amount: null,
        merchant_id: null
      },
      checkedRelateMch: {},
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      relatedMerchantsList: []
    }
  },
  created() {
    this.getRelateMchList()
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogVisible = value
      // 清楚校验提示
    },
    handleDialogClose() {
      this.$refs['transForm'].clearValidate()
    },
    getRelateMchList() {
      fetchRelateMchsList().then(res => {
        this.relatedMerchantsList = res.data
      })
    },
    onChangeRelatedMch(id) {
      const relatedItem = this.relatedMerchantsList.find(item => item.id === id)
      if (relatedItem) {
        this.checkedRelateMch = JSON.parse(JSON.stringify(relatedItem))
        this.checkedRelateMch.balance = relatedItem.last_mch_balance ? relatedItem.last_mch_balance.balance : 0
      }
    },
    onClickSubmitBtn() {
      this.$refs.transForm.validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = {
            ...this.transForm,
            amount: this.$commonFn.mathMultiply(Number(this.transForm.amount), 100)
          }
          mchRelateTransfer(params).then(res => {
            this.changModalStatus(false)
            this.$emit('get-merchant-info')
            this.$message.success('Transfer SuccessFully')
            this.transForm = {
              amount: null,
              remark: null,
              merchant_id: null
            }
            this.checkedRelateMch = {}
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title{
  margin: 0;
  margin-bottom: 13px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  text-align: center;
}
.tip{
  padding: 0;
  margin:0;
  margin-top: -18px;
  font-size: 14px;
  font-weight: 400;
  color: #303133;
  text-align: right;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  // margin-top: 20px;
  height: 40px;
  border-radius: 4px;
}
.select-item{
  width: 100%;
}
</style>
